module.exports = __webpack_public_path__ + "img/illustration.41bdbc13.svg";